<!-- Input Group -->
<div
	class="row mx-0 filter-input-group"
	[ngClass]="{
		'focused': isFocused
	 }"
>

	<input
		title="{{ getI18nString(
			false,
			defaultFilterData?.items[0]?.i18nPath + '.placeholder'
		) }}"
		type="text"
		class="col px-2 fs-md filterTextString"
		[ngClass]="{'active': textFilterValue?.length }"
		[(ngModel)]="textFilterValue"
		(focusin)="isFocused = true"
		(focusout)="isFocused = false"
		(ngModelChange)="onInputChange($event)"
	/>

	<!-- Actions -->
	<!-- TODO: add title attributes -->
	<div class="d-flex col-auto px-0 input-actions">

		<!-- TODO Sidebar remove container and keep svgs if no old support is needed anymore -->
		<ng-container *ngIf="sidebar">
			<!-- Clear Icon -->
			<app-svg
				*ngIf="showClearButton"
				class="input-group-text"
				[size]="svgSizeEnum.SMALL"
				[type]="svgTypeEnum.CLEAR"
				(click)="clearControlValue()"
			></app-svg>

			<!-- Revert Icon -->
			<app-svg
				*ngIf="showRevertButton"
				class="input-group-text"
				[size]="svgSizeEnum.SMALL"
				[type]="svgTypeEnum.REVERT"
				(click)="revertControlValue()"
			></app-svg>
		</ng-container>

		<!-- TODO OLD remove completely if no old support is needed anymore -->
		<ng-container *ngIf="!sidebar">
			<div *ngIf="showClearButton">
				<i
					class="input-group-text ft-x"
					(click)="clearControlValue()"
				></i>
			</div>

			<div *ngIf="showRevertButton">
				<i
					class="input-group-text icon-action-undo"
					(click)="revertControlValue()"
				></i>
			</div>
		</ng-container>
	</div>
</div>
